import React from 'react'
import classNames from 'classnames'
import './option.css'
import { SelectOptionProps } from './interface'

const Option = (props: SelectOptionProps) => {
  const {
    children,
    className,
    style,
    active,
    disabled,
    onClick,
    readonly,
    onMouseEnter,
    hover,
  } = props
  return (
    <div
      className={classNames('zySelectOption', className)}
      data-active={active}
      data-hover={hover}
      data-disabled={disabled}
      data-readonly={readonly}
      style={style}
      onClick={(ev) => {
        if (readonly || disabled) return
        onClick?.(ev)
      }}
      onMouseEnter={(ev) => {
        if (disabled) return
        onMouseEnter?.(ev)
      }}
    >
      {children}
    </div>
  )
}

export default Option
